import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import ContactSetEditor from "../Contacts/ContactSetEditor";
import { selectProjectUUID } from "../store/slices/projectSlice";
import { selectSendLists, setSendLists } from "../store/slices/sendListsSlice";
import { selectBroadcast, setUsedFile } from "../store/slices/broadcastSlice";

export default function BroadcastContacts({
  onSave,
  uuid,
  setSendListUUID,
  uuidType,
  initialSendlist,
  setTotal,
  showFileImportOption,
  importedFile,
  setFile,
  headers,
  setBroadcastData,
}) {
  const broadcastData = useSelector(selectBroadcast);
  const sendLists = useSelector(selectSendLists);
  const dispatch = useDispatch();
  const projectUUID = useSelector(selectProjectUUID);
  const [sendList, setSendList] = useState();
  const [contactSet, setContactSet] = useState();
  const [contactSets, setContactSets] = useState();
  const [ignoredContactSets, setIgnoredContactSets] = useState();
  const [sendListOptions, setSendListOptions] = useState({
    // ignore: true, // <-- new option
    uuids: [],
    ignoreContacts: [],
    ignoreSets: [],
    contacts: [],
    sets: [],
  });

  const saveSendList = async () => {
    if (
      sendList?.add?.length > 0 ||
      contactSets?.length > 0 ||
      contactSet?.filters?.length > 0 ||
      sendLists.some((sl) => sl.uuid === uuid)
    ) {
      const bodyContent = {
        uuid,
        uuidType,
        projectUuid: projectUUID,
        contacts: sendList?.add,
        ignoredContacts: sendList?.remove,
        contactSets,
        ignoredContactSets,
        clearStatic: sendList?.clearStatic,
        filters: contactSet?.filters,
      };
      dispatch(
        setSendLists([
          ...sendLists.filter((sl) => sl.uuid !== uuid),
          bodyContent,
        ])
      );

      // update ContactSetUUID
      onSave?.();
    }
  };

  const getSendList = async () => {
    const data = sendLists.find((sl) => sl.uuid === uuid);
    setSendList({
      clearStatic: false,
      add: initialSendlist?.contacts || data?.contacts || [],
      remove: [],
    });
    setContactSet({ uuid, filters: data?.filters || [] });
    setContactSets(initialSendlist?.contactSets || data?.contactSets || []);
    setIgnoredContactSets(
      initialSendlist?.ignoredContactSets || data?.ignoredContactSets || []
    );
    setSendListOptions({
      uuids: [uuid],
      ignoreContacts: [],
      ignoreSets: [],
      contacts: [],
      sets: [],
    });
  };

  const location = useLocation();

  useEffect(() => {
    saveSendList();
  }, [sendList, contactSet?.filters, contactSets]);

  useEffect(() => {
    getSendList();
  }, []);

  return (
    sendList &&
    contactSet &&
    contactSets && (
      <>
        <ContactSetEditor
          isRuntimeContacts
          hideFilters
          contactSet={contactSet}
          setContactSet={setContactSet}
          key={uuid}
          sendList={sendList}
          setTotal={setTotal}
          setSendList={(fn) => {
            setSendList((p) => fn(p));
            setSendListOptions((p) => {
              const newSL = fn({
                add: p.contacts,
                remove: p.ignoreContacts,
                clearStatic: p.clearStatic,
              });
              return {
                ...p,
                ignoreContacts: newSL.remove,
                contacts: newSL.add,
                clearStatic: newSL.clearStatic,
              };
            });
          }}
          contactSets={contactSets}
          setContactSets={(fn) => {
            if (typeof fn === "function") {
              setContactSets((p) => fn(p));
              setSendListOptions((p) => ({
                ...p,
                sets: fn(p.sets),
              }));
            }
          }}
          ignoredContactSets={ignoredContactSets}
          setIgnoredContactSets={(fn) => {
            if (typeof fn === "function") {
              setIgnoredContactSets((p) => fn(p));
              setSendListOptions((p) => ({
                ...p,
                ignoreSets: fn(p.ignoreSets),
              }));
            }
          }}
          initialSearchType={
            location.state?.searchType ||
            (uuid === "broadcast-import-file" ? "file-import" : undefined)
          }
          sendListOptions={
            sendListOptions.uuids?.[0] === "broadcast-sendlist" ||
            sendListOptions.clearStatic
              ? undefined
              : sendListOptions
          }
          showFileImportOption={showFileImportOption}
          importedFile={importedFile}
          setFile={setFile}
          headers={headers}
          highlighChannelsIfNotAvailable={
            broadcastData?.Messages.map(
              (m) => `is${m.Channel[0].toUpperCase()}${m.Channel.slice(1)}`
            ) || []
          }
          onChangeDataSource={(source) => {
            if (source === "file-import") {
              setSendListUUID("broadcast-import-file");
            } else {
              dispatch(setUsedFile(undefined));
              setSendListUUID("broadcast-sendlist");
              setBroadcastData({
                ...broadcastData,
                File: "",
                IsFileImport: false,
              });
            }
          }}
        />
        <JsonCollapse
          json={{ contactSet, sendList, contactSets, ignoredContactSets }}
        />
      </>
    )
  );
}
